<template>
    <div class="confirmation">
        <h1 class="hero-title">Thank you for your order!</h1>
        <p>
            A confirmation email was sent to {{ order.paypal_email }}.
        </p>
        <div class="order-confirmation">

            <h2>Order #{{ order.order_token }}</h2>
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <h3>Billing</h3>
                        Payment method: PAYPAL
                        <br/>
                        {{ order.paypal_first_name }} {{ order.paypal_last_name }}
                        <br/>
                        {{ order.paypal_email }}
                    </div>
                    <div class="column">
                        <h3>Shipping</h3>
                        <strong>{{ order.shipping_provider }} {{ order.shipping_service }} (~{{ order.shipping_estimate + 5 }} days)</strong>
                        <br/>
                        {{ order.first_name }} {{ order.last_name }}
                        <br/>
                        {{ order.email }}
                        <br v-if="order.phone !== null"/>
                        {{ order.phone }}
                        <br/>
                        {{ order.address1 }} {{ order.address2 }}
                        <br/>
                        {{ order.city }}, {{ order.state }} {{ order.zip }}
                    </div>
                </div>
            </div>
            <h3>Items</h3>
            <div>
                <div v-for="item in order.items">
                    {{ item.item }} -
                    {{ item.color }} -
                    {{ item.price | currency }}
                </div>
            </div>
            <br/>
            <div class="has-text-right">
                Subtotal: {{ order.subtotal | currency }}
                <br/>
                Shipping: {{ order.shipping | currency }}
                <br/>
                Tax: {{ order.tax | currency }}
                <br/>
                Total: {{ order.total | currency }}
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: 'Confirmation',
        computed: mapGetters(['order']),
    }
</script>


// WEBPACK FOOTER //
// Confirmation.vue?019c35fb